export interface DESCRIPTION_LIST {
	heading: string;
	item: string;
}

export const DEFAULT_LABELS = {
	title: 'Maximize Your Reach with the Beacon Discovery Social Media Kit',
	description_text:
		'Easily showcase your presence on Beacon Discovery with tools designed to help you stand out to retailers and partners.',
	description_download:
		"Download your Social Media Kit below and start amplifying your brand's visibility today!",
	button_text: 'Download your Social Media Kit',
	list_heading: 'Your Social Media Kit includes:',
	tip_description:
		'Did you know you can share your Beacon Discovery profile or product page with a simple link? Pair it with the tools in your Social Kit to make sharing with retailers and partners even easier.'
};

export const description_list: DESCRIPTION_LIST[] = [
	{
		heading: '1. Customizable Frames: ',
		item: 'Highlight your brand by adding images and sharing on social media.'
	},
	{
		heading: '2. Email Signature Badge: ',
		item: 'Link directly to your Beacon profile so partners can learn about your brand.'
	},
	{
		heading: '3. Beacon Discovery Logos: ',
		item: 'Display your affiliation on your website, newsletters, and beyond.'
	}
];

export const ZIPFILE_LINK =
	'https://beacon.newhope.com/wp-content/uploads/2025/09/BeaconSocialKit2025.zip';
